import { styled } from "../../../stitches.config";
import React from 'react';
import Logo from "../../atoms/Logo";
import { h1, h2, h3, h4, p } from '../../commonStyles/Fonts';

type BrandCardProps = {
    text: string,
    children: JSX.Element[]
}

const BrandCard = ({ text, children }: BrandCardProps) => {

    return (
        <Card>
            {children}
            <p className={p()}>{text}</p>
        </Card>
    )
}

export default BrandCard;

const Card = styled('div', {
    position: 'relative',
    backgroundColor: '$grayscale0',
    color: '$grayscale100',
    width: '100%',
    padding: '24px',
    'p': {
        position: 'inherit',
        zIndex: 10,
    },
    '.mamadu-circles': {
        'svg': {
            'path': {
                stroke: '$mamaduPrimary',
            }
        }
    },
    '.aszdziennik-circles': {
        'svg': {
            'path': {
                stroke: '$aszdziennikPrimary',
            }
        }
    },
    '.innpoland-circles': {
        'svg': {
            'path': {
                stroke: '$innpolandPrimary',
            }
        }
    },
    '.dadhero-circles': {
        'svg': {
            'path': {
                stroke: '$dadheroPrimary',
            }
        }
    },
    '@bp4': {
        width: '408px',
        padding: '40px',
        'p': {
            zIndex: 10,
        },
        '.natematlogo': {
            width: '150px',
        },
        '.mamadulogo': {
            width: '151px',
        },
        '.aszdzienniklogo': {
            width: '212px',
        },
        '.innpolandlogo': {
            width: '186px',
        },
        '.dadherologo': {
            width: '172px',
        }
    },
    '.natematlogo': {
        width: '125px',
    },
    '.mamadulogo': {
        width: '126px',
    },
    '.aszdzienniklogo': {
        width: '177px',
    },
    '.innpolandlogo': {
        width: '155px',
    },
    '.dadherologo': {
        width: '143px',
    }
})